/**
 * The result of calling `testUrl`.
 *
 * 'http-error' indicated the server responded with something other than a
 * 2xx - exactly the same as when `response.ok` is false.
 *
 * 'network-error' indicates the attempted connection threw an error
 * (including a signal abort)
 */
export type UrlProbeResult = 'ok' | 'http-error' | 'network-error';

/**
 * Tests the given `url` by sending it a `HEAD` request.
 */
export async function testUrl(
    url: string,
    signal?: AbortSignal
): Promise<UrlProbeResult> {
    let response: Response;
    try {
        response = await fetch(url, { method: 'HEAD', signal });
    } catch {
        return 'network-error';
    }

    return response.ok ? 'ok' : 'http-error';
}
